import {Injectable} from '@angular/core';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {ReportAccountComponentModel} from '../../../api/entity/reportAccountComponent.model';
import {ReportAccountComponentConverter} from '../../../api/entity/converter/reportAccountComponent.converter';
import {ReportAccountComponentDataService} from './reportAccountComponentData.service';


@Injectable()
export class ReportAccountComponentDataServiceAdapter
    extends AbstractDataServiceDtoAdapter<ReportAccountComponentModel, ReportAccountComponentConverter> {
    constructor(dataService: ReportAccountComponentDataService, converter: ReportAccountComponentConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): ReportAccountComponentModel {
        return new ReportAccountComponentModel();
    }
}
